export const NursingStudentList = () => {
  return <div>NursingStudentList</div>;
};
